export default __webpack_public_path__ + "assets/piscine-condo-moderne-quebec.0d119e56.webp";